import familiadosApiClient from '$utils/familiadosApiClient'
import { apiErrorService } from '$utils/services/apiErrorService'
import { CaretakerDto } from '$domain/model/caretaker/caretakerList/caretakerList.model'
import { modelToCaretakerList } from '$domain/model/caretaker/caretakerList/caretakerList.mapper'

export const caretakerListPath = '/caretakers'

export const getCaretakerList = async (latitude: number, longitude: number, limit?: number, offset?: number) => {
  try {
    const caretakerListResponse = await familiadosApiClient.get<CaretakerDto[]>(caretakerListPath, {
      latitude,
      longitude,
      limit,
      offset,
    })
    return modelToCaretakerList(caretakerListResponse)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/caretaker/caretakerList/caretakerList.manager.ts